// Fragment "custom domain lifecycle" — the practitioner's Domain page (admin/CustomDomainAdmin.jsx)
// for the five statuses of backend/modules/custom_domains (pending_dns, provisioning, live,
// failed, lapsed), the DNS finding codes and the edge failure codes the server returns.
// Merged by ./index.js.
export default {
  fr: {
    "cdom.placeholder": "www.moncabinet.com",
    "cdom.status.none": "Aucun domaine",
    "cdom.status.pending_dns": "En attente du DNS",
    "cdom.status.provisioning": "Sécurisation en cours",
    "cdom.status.live": "En ligne",
    "cdom.status.failed": "Action requise",
    "cdom.status.lapsed": "Déconnecté",
    "cdom.stepAdd": "Ajoute les enregistrements ci-dessous, puis clique sur Vérifier. Nous revérifions aussi automatiquement toutes les heures.",
    "cdom.apexNote": "C'est un domaine racine : ajoute ces enregistrements A et supprime tout autre enregistrement A ou AAAA de ce nom.",
    "cdom.check": "Vérifier",
    "cdom.retry": "Réessayer",
    "cdom.checkNow": "Vérifier maintenant",
    "cdom.provisioning": "Tes enregistrements sont corrects. Nous obtenons le certificat de sécurité de {domain} — cela prend en général quelques minutes. Nous t'enverrons un e-mail dès que c'est en ligne.",
    "cdom.live": "Ton site est en ligne sur",
    "cdom.liveNote": "Tous les liens envoyés à tes clients utilisent maintenant ce domaine.",
    "cdom.failed": "Nous n'avons pas pu sécuriser {domain}.",
    "cdom.failedHint": "Corrige les enregistrements ci-dessous si besoin, puis clique sur Réessayer. En attendant, tes liens restent sur ton adresse Solunary.",
    "cdom.lapsed": "{domain} ne pointe plus vers Solunary depuis le {since}. Tes liens sont revenus sur ton adresse Solunary.",
    "cdom.lapsedRelease": "Rétablis les enregistrements avant le {date}, sinon le domaine sera retiré de ton cabinet.",
    "cdom.unprovenRelease": "Si le domaine n'est pas connecté d'ici le {date}, il sera libéré pour ne pas rester bloqué.",
    "cdom.findingsTitle": "Ce que nous avons trouvé",
    "cdom.found": "Trouvé : {value}",
    "cdom.edgeError": "L'hébergement sécurisé n'a pas pu être joint. Rien n'est perdu : nous réessayons automatiquement.",
    "cdom.code.TXT_MISSING": "L'enregistrement TXT de vérification est introuvable.",
    "cdom.code.TXT_MISMATCH": "L'enregistrement TXT existe mais sa valeur ne correspond pas.",
    "cdom.code.CNAME_MISSING": "L'enregistrement CNAME est introuvable.",
    "cdom.code.CNAME_MISMATCH": "Le CNAME pointe ailleurs que vers {target}.",
    "cdom.code.APEX_RECORDS_MISSING": "Aucun enregistrement A trouvé pour ce domaine.",
    "cdom.code.APEX_RECORDS_MISMATCH": "Des enregistrements A pointent ailleurs que vers Solunary.",
    "cdom.code.APEX_UNAVAILABLE": "Les domaines racine ne sont pas encore disponibles. Utilise un sous-domaine comme www.",
    "cdom.code.DNS_INCONCLUSIVE": "Le DNS n'a pas répondu à temps. Réessaie dans quelques minutes.",
    "cdom.code.DOMAIN_IN_USE_ON_EDGE": "Ce domaine est déjà rattaché à un autre service d'hébergement (CloudFront). Retire-le de là-bas, puis réessaie.",
    "cdom.code.EDGE_REJECTED": "Notre hébergeur a refusé ce domaine. Vérifie l'orthographe ou contacte le support.",
    "cdom.code.CERT_FAILED": "Le certificat n'a pas pu être émis : le domaine ne pointait pas vers Solunary au moment de la validation.",
    "cdom.code.EDGE_UNAVAILABLE": "L'hébergement sécurisé est momentanément indisponible.",
    "cdom.err.DOMAIN_TAKEN": "Ce domaine est déjà utilisé par un autre cabinet.",
    "cdom.err.DOMAIN_IS_PLATFORM": "Les adresses Solunary se gèrent dans l'assistant de site, pas ici.",
    "cdom.err.INVALID_DOMAIN": "Ce n'est pas un nom de domaine valide.",
    "cdom.err.APEX_UNAVAILABLE": "Les domaines racine ne sont pas encore disponibles. Utilise un sous-domaine comme www.",
    "cdom.err.CONCURRENT_UPDATE": "Le domaine a changé entre-temps. Recharge la page.",
  },
  en: {
    "cdom.placeholder": "www.myclinic.com",
    "cdom.status.none": "No domain",
    "cdom.status.pending_dns": "Waiting for DNS",
    "cdom.status.provisioning": "Securing",
    "cdom.status.live": "Live",
    "cdom.status.failed": "Action needed",
    "cdom.status.lapsed": "Disconnected",
    "cdom.stepAdd": "Add the records below, then click Verify. We also re-check automatically every hour.",
    "cdom.apexNote": "This is a root domain: add these A records and remove any other A or AAAA record on this name.",
    "cdom.check": "Verify",
    "cdom.retry": "Retry",
    "cdom.checkNow": "Check now",
    "cdom.provisioning": "Your records are correct. We're obtaining the security certificate for {domain} — this usually takes a few minutes. We'll email you as soon as it's live.",
    "cdom.live": "Your site is live at",
    "cdom.liveNote": "Every link sent to your clients now uses this domain.",
    "cdom.failed": "We couldn't secure {domain}.",
    "cdom.failedHint": "Fix the records below if needed, then click Retry. Meanwhile your links stay on your Solunary address.",
    "cdom.lapsed": "{domain} has not pointed to Solunary since {since}. Your links moved back to your Solunary address.",
    "cdom.lapsedRelease": "Restore the records before {date}, or the domain will be removed from your practice.",
    "cdom.unprovenRelease": "If the domain isn't connected by {date}, it will be released so it isn't held indefinitely.",
    "cdom.findingsTitle": "What we found",
    "cdom.found": "Found: {value}",
    "cdom.edgeError": "Secure hosting couldn't be reached. Nothing is lost — we retry automatically.",
    "cdom.code.TXT_MISSING": "The verification TXT record wasn't found.",
    "cdom.code.TXT_MISMATCH": "The TXT record exists but its value doesn't match.",
    "cdom.code.CNAME_MISSING": "The CNAME record wasn't found.",
    "cdom.code.CNAME_MISMATCH": "The CNAME points somewhere other than {target}.",
    "cdom.code.APEX_RECORDS_MISSING": "No A record was found for this domain.",
    "cdom.code.APEX_RECORDS_MISMATCH": "Some A records point somewhere other than Solunary.",
    "cdom.code.APEX_UNAVAILABLE": "Root domains aren't available yet. Use a subdomain such as www.",
    "cdom.code.DNS_INCONCLUSIVE": "DNS didn't answer in time. Try again in a few minutes.",
    "cdom.code.DOMAIN_IN_USE_ON_EDGE": "This domain is already attached to another hosting service (CloudFront). Remove it there, then try again.",
    "cdom.code.EDGE_REJECTED": "Our hosting provider refused this domain. Check the spelling or contact support.",
    "cdom.code.CERT_FAILED": "The certificate couldn't be issued: the domain wasn't pointing to Solunary when it was validated.",
    "cdom.code.EDGE_UNAVAILABLE": "Secure hosting is temporarily unavailable.",
    "cdom.err.DOMAIN_TAKEN": "This domain is already used by another practice.",
    "cdom.err.DOMAIN_IS_PLATFORM": "Solunary addresses are managed in the site wizard, not here.",
    "cdom.err.INVALID_DOMAIN": "That isn't a valid domain name.",
    "cdom.err.APEX_UNAVAILABLE": "Root domains aren't available yet. Use a subdomain such as www.",
    "cdom.err.CONCURRENT_UPDATE": "The domain changed meanwhile. Reload the page.",
  },
  es: {
    "cdom.placeholder": "www.miconsulta.com",
    "cdom.status.none": "Sin dominio",
    "cdom.status.pending_dns": "Esperando el DNS",
    "cdom.status.provisioning": "Protegiendo",
    "cdom.status.live": "En línea",
    "cdom.status.failed": "Acción necesaria",
    "cdom.status.lapsed": "Desconectado",
    "cdom.stepAdd": "Añade los registros de abajo y haz clic en Verificar. También lo comprobamos automáticamente cada hora.",
    "cdom.apexNote": "Es un dominio raíz: añade estos registros A y elimina cualquier otro registro A o AAAA de este nombre.",
    "cdom.check": "Verificar",
    "cdom.retry": "Reintentar",
    "cdom.checkNow": "Comprobar ahora",
    "cdom.provisioning": "Tus registros son correctos. Estamos obteniendo el certificado de seguridad de {domain}; suele tardar unos minutos. Te escribiremos en cuanto esté en línea.",
    "cdom.live": "Tu sitio está en línea en",
    "cdom.liveNote": "Todos los enlaces que reciben tus clientes usan ahora este dominio.",
    "cdom.failed": "No pudimos proteger {domain}.",
    "cdom.failedHint": "Corrige los registros de abajo si hace falta y haz clic en Reintentar. Mientras tanto, tus enlaces siguen en tu dirección de Solunary.",
    "cdom.lapsed": "{domain} no apunta a Solunary desde el {since}. Tus enlaces volvieron a tu dirección de Solunary.",
    "cdom.lapsedRelease": "Restablece los registros antes del {date}; si no, el dominio se quitará de tu consulta.",
    "cdom.unprovenRelease": "Si el dominio no está conectado antes del {date}, se liberará para que no quede bloqueado.",
    "cdom.findingsTitle": "Lo que encontramos",
    "cdom.found": "Encontrado: {value}",
    "cdom.edgeError": "No se pudo contactar con el alojamiento seguro. No se pierde nada: lo reintentamos automáticamente.",
    "cdom.code.TXT_MISSING": "No se encontró el registro TXT de verificación.",
    "cdom.code.TXT_MISMATCH": "El registro TXT existe, pero su valor no coincide.",
    "cdom.code.CNAME_MISSING": "No se encontró el registro CNAME.",
    "cdom.code.CNAME_MISMATCH": "El CNAME apunta a otro sitio que no es {target}.",
    "cdom.code.APEX_RECORDS_MISSING": "No se encontró ningún registro A para este dominio.",
    "cdom.code.APEX_RECORDS_MISMATCH": "Algunos registros A apuntan a otro sitio que no es Solunary.",
    "cdom.code.APEX_UNAVAILABLE": "Los dominios raíz aún no están disponibles. Usa un subdominio como www.",
    "cdom.code.DNS_INCONCLUSIVE": "El DNS no respondió a tiempo. Inténtalo de nuevo en unos minutos.",
    "cdom.code.DOMAIN_IN_USE_ON_EDGE": "Este dominio ya está conectado a otro servicio de alojamiento (CloudFront). Quítalo de allí e inténtalo de nuevo.",
    "cdom.code.EDGE_REJECTED": "Nuestro proveedor de alojamiento rechazó este dominio. Revisa cómo está escrito o contacta con soporte.",
    "cdom.code.CERT_FAILED": "No se pudo emitir el certificado: el dominio no apuntaba a Solunary en el momento de la validación.",
    "cdom.code.EDGE_UNAVAILABLE": "El alojamiento seguro no está disponible por el momento.",
    "cdom.err.DOMAIN_TAKEN": "Este dominio ya lo usa otra consulta.",
    "cdom.err.DOMAIN_IS_PLATFORM": "Las direcciones de Solunary se gestionan en el asistente del sitio, no aquí.",
    "cdom.err.INVALID_DOMAIN": "No es un nombre de dominio válido.",
    "cdom.err.APEX_UNAVAILABLE": "Los dominios raíz aún no están disponibles. Usa un subdominio como www.",
    "cdom.err.CONCURRENT_UPDATE": "El dominio cambió mientras tanto. Vuelve a cargar la página.",
  },
};
